import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { OF } from "../../../of/models/of.model";
import { OfFacadeService } from "./of-facade.service";

@Injectable({ providedIn: "root" })
export class OfStoreService extends EntityStoreService<
  OF,
  EntityMetadata,
  OFState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface OFState extends EntityStoreState<OfFacadeService> {}
